import { Button, Col, DatePicker, Form, InputNumber, Row, Spin, Descriptions, message, Input, Result} from "antd"
import { useState, useEffect } from "react"
import{ AllCompanyInfo} from "@operations/shared";
import { ModalComponent } from '@operations/shared';
import { useDispatch } from "react-redux";
import { request } from "../../../../shared/src/apis";
import { getOneCompanyApi, getUserInfoApi, addCollectionsApi } from "../../utils/apisConsts";
import { getDataInfo, stepperMoving } from "../../stores/actions";
import moment from "moment";
import { errorMessage } from "../../utils/commonStringsConsts";
import { IUserInfo, ICompany, IAddCollections, IAddCollectionsPayload } from '../../utils/commonInterfaces';
import { OutPutResult } from '@operations/shared';
import helper from "../../utils/helper";


export default function SubmitAddCollection({ isCompany, identifier }: IAddCollections) {
    const [fetchedInfo, setFetchedInfo] = useState<ICompany | IUserInfo>()
    const [openConfirmationModal, setConfirmationModal] = useState(false)
    const [amount, setAmount] = useState<number>(0);
    const [errorMode, setErrorMode] = useState(false)
    const [loading, setLoading] = useState(false);
    const [collectionPayload, setCollectionPayload] = useState<IAddCollectionsPayload>();
    const [assignedToInvoice, setAssignedToInvoice] = useState<boolean>(false);
    const [form] = Form.useForm();
    const dispatch = useDispatch()
    const [amounts, setAmounts] = useState({
        beforeAmount: 0,
        afterAmount: 0,
    })
    useEffect(() => {
        fetchInitialData()
        // .then((payer) => identifier && getPaymentCycles(payer))

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const onAmountChange = (newAmount: number) => {
            setAmount(newAmount);
        const updatedAfterAmount = amounts?.afterAmount + (amount - newAmount);
        setAmounts({
            ...amounts,
            afterAmount: updatedAfterAmount
        });
        setAmount(newAmount);

    }

    const handleSubmit = async (values: any) => {
        let collectionData: IAddCollectionsPayload = {
            ...(isCompany ?
                { companyID: identifier }
                : {
                    phone: identifier, paymentCycle: values?.paymentCycle,
                    // startEarly: values?.startEarly,
                }),
            amount: values?.amount,
            collectionDate: moment(values?.collectionDate).format("YYYY-MM-DD"),
            referenceNumber: values?.referenceNumber,
        }
        setCollectionPayload(collectionData);
        if (!identifier) {
            setConfirmationModal(true);
        }
        else {
            submitAddCollection(collectionData);
        }
    }
    const confirmationModal = () => {
        setConfirmationModal(false);
        if (collectionPayload) {
            submitAddCollection(collectionPayload);
        }
    };

    const handleCloseModal = () => {
        setConfirmationModal(false);
    };

    const fetchInitialData = async () => {
        if (!identifier) return
        try {
            const resData: { [key: string]: any } = await dispatch(request({ url: isCompany ? `${getOneCompanyApi}/${identifier}` : `${getUserInfoApi}?phone=${identifier}` }))
            if (resData?.data?.status === 200) {
                setFetchedInfo(isCompany ? resData?.data?.data : resData?.data?.userInfo)
                isCompany && dispatch(getDataInfo(resData?.data?.data))
                return resData?.data
            } else {
                setErrorMode(true)
                message.error(resData?.data?.message)
            }
        }
        catch (error: any) {
            setErrorMode(true)
            message.error(error)
        }
    }

    const submitAddCollection = async (collectionData: IAddCollectionsPayload) => {
        try {
            setLoading(true)
            const res: any = await dispatch(request({
                url: addCollectionsApi, method: "POST",
                data: collectionData
            }))
            if (res?.data?.status === 200) {
                message.success(res?.data?.message)
                if (!identifier) {
                    setAssignedToInvoice(true)
                    setLoading(false)
                    return
                }
                dispatch(stepperMoving(0))
            } else {
                message.error(res?.data?.message)
            }
            setLoading(false)
        }
        catch (error: any) {
            message.error(errorMessage)
            setLoading(false)
        }

    }
    const confirmationAssigningToInvoice = () => {
        setAssignedToInvoice(false)
        dispatch(stepperMoving(0))
    }

    const handelCloseAssigningToInvoice = () => {
        setAssignedToInvoice(false)
        dispatch(stepperMoving(0))
    }

    return (
        errorMode ? <OutPutResult status={'500'} title={'Oops!'} subTitle={errorMessage ? errorMessage : 'Something went wrong, please refresh the page and try again'}
            btnTitle={'Refresh the page'} btnClick={helper.refreshPage} /> :
            <div className="createEarlyPayment">
                <Spin size="large" spinning={false}>
                    <Form name="nest-messages" onFinish={handleSubmit} form={form}>
                        <Row className="inputsRow">
                            <Col span={8}>
                                <label>Collection Amount <span>*</span></label>
                                <Form.Item
                                    name="amount"
                                    rules={[{ required: true, message: 'Required' }, { type: "number", min: 1 }]}
                                >
                                    <InputNumber placeholder="Enter amount" onChange={(e: number) => onAmountChange(e)} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <label>Collection Date <span>*</span></label>
                                <Form.Item name="collectionDate"
                                    rules={[{ required: true, message: 'Required' }]}>
                                    <DatePicker format={"YYYY/MM/DD"} disabledDate={(current) => {
                                        return current && current > moment().endOf('day');
                                    }} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <label>Reference Number <span>*</span></label>
                                <Form.Item name="referenceNumber"
                                    rules={[{ required: true, message: 'Required' }]}>
                                    <Input placeholder="Enter reference number" />
                                </Form.Item>
                            </Col>
                            <Col span='24' className="btnCol">
                                <Form.Item>
                                    <Button shape="round" type="primary" block htmlType="submit" loading={loading}>
                                        Submit
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    <Row>
                        <Col span={24}>
                            {
                                (fetchedInfo && identifier) && (
                                    isCompany ? <AllCompanyInfo /> :
                                        <>
                                            <h3>User information</h3>
                                            <Descriptions bordered style={{ margin: '15px 0' }}>
                                                <Descriptions.Item label="Name">{fetchedInfo?.name ? fetchedInfo?.name : 'NA'}</Descriptions.Item>
                                                <Descriptions.Item label="Phone">{fetchedInfo?.phone ? fetchedInfo?.phone : 'NA'}</Descriptions.Item>
                                                <Descriptions.Item label="Company">{fetchedInfo?.companyName ? fetchedInfo?.companyName : 'NA'}</Descriptions.Item>
                                            </Descriptions>
                                        </>
                                )
                            }
                        </Col>
                    </Row>
                    <ModalComponent visibleModal={openConfirmationModal} handleAcceptModal={confirmationModal} loadingConfirm={loading} okText='Proceed'
                        content={<p>The collection of {<span className="font-semibold underline">{amount} SAR</span>} will be added as an unidentified collection, would you like to proceed?</p>} title='Warning Message' handleCloseModal={handleCloseModal}
                    />
                    <ModalComponent visibleModal={assignedToInvoice} handleAcceptModal={confirmationAssigningToInvoice} loadingConfirm={loading} okText='Okay' none='none'
                        content={
                            <Result
                                status="success"
                                title="The collection has been successfully added."
                                subTitle="Do you want to proceed to assign the collection on an invoice?"
                            />
                        }
                        title='Success message' handleCloseModal={handelCloseAssigningToInvoice}
                    />
                </Spin>
            </div>
    )
}